import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { DevHeaderComponent } from './dev-header';
import { AccountMenuComponentModule } from './account-menu/account-menu.module'
@NgModule({
  declarations: [
    DevHeaderComponent,
  ],
  entryComponents: [
    DevHeaderComponent
  ],
  imports: [
    IonicModule,
    AccountMenuComponentModule
  ],
  exports: [
    DevHeaderComponent
  ]
})
export class DevHeaderComponentModule { }



// WEBPACK FOOTER //
// ./src/components/dev-header/dev-header.module.ts